import { posAccountsUtils } from 'components/PosAccounts/utils'
import { apiDataPreparation } from 'components/PosAccounts/utils/apiDataPreparation'
import { isChangedValue } from 'utils/formik'

export const handleAttendantFormSubmit = (
  values,
  initialValues,
  currentAttendant,
  isNewPosAccount,
  orgName,
  onCreateAttendant,
  onUpdateAttendant
) => {
  const { name, phone, email, pinNumber, employeeId, role } = values

  const createPosAccountValues = {
    name,
    phone,
    email,
    pinNumber,
    employeeId: posAccountsUtils.getValidEmployeeId(
      employeeId,
      orgName,
      name
    ),
    role,
  }

  const updatePosAccountValues =
    apiDataPreparation.getPreparedAttendantsData(
      values,
      initialValues,
      employeeId,
      orgName,
      name,
      currentAttendant.uuid
    )

  const createEmployeeRoleData = {
    employeeId: currentAttendant?.employeeId,
    role: role,
    type:
      role === 'manager'
        ? 'ManagerEmployeeRole'
        : 'AttendantEmployeeRole',
  }

  if (isNewPosAccount) {
    const createAttendantWithRoleData = {
      attendantData: createPosAccountValues,
      roleData: createEmployeeRoleData,
    }

    return onCreateAttendant(createAttendantWithRoleData)
  } else {
    const updateAttendantWithRoleData = {
      attendantData: updatePosAccountValues,
      roleData: isChangedValue(initialValues.role, role)
        ? createEmployeeRoleData
        : {},
      uuid: currentAttendant?.uuid,
    }

    return onUpdateAttendant(updateAttendantWithRoleData)
  }
}
